import{WalletsRevoke as r}from"@privy-io/public-api";class t{async revoke(){await this._privyInternal.fetch(r,{})}constructor(r){this._privyInternal=r}}export{t as default};
